import { NutrientGroupDto } from '../../shared/models/models';

export class BemUtils {

  static hasValidData(nutrientGroup: NutrientGroupDto): boolean {
    if (!nutrientGroup?.sampleDate) {
      return false;
    }

    // Check for any advice text arrays with content or numeric values
    return [
      (nutrientGroup.nAdviceTxt?.length ?? 0) > 0,
      (nutrientGroup.kAdviceTxt?.length ?? 0) > 0,
      (nutrientGroup.mgAdviceTxt?.length ?? 0) > 0,
      (nutrientGroup.mnAdviceTxt?.length ?? 0) > 0,
      (nutrientGroup.bAdviceTxt?.length ?? 0) > 0,
      (nutrientGroup.so3AdviceTxt?.length ?? 0) > 0,
      typeof nutrientGroup.nRecKgha === 'number',
      typeof nutrientGroup.nMinKgha === 'number',
      typeof nutrientGroup.kRecKgha === 'number',
      typeof nutrientGroup.mgRecKgha === 'number',
    ].some(Boolean);
  }

  static seperateNutrientAndTextId(input: string): { nutrient: string; textId: string } | null {
    const regex = /^([a-zA-Z]+)(\d+)$/;
    const match = regex.exec(input);

    if (!match) {
      return null;
    }
    const letters = match[1].charAt(0).toUpperCase() + match[1].slice(1).toLowerCase();
    const number = match[2];

    return { nutrient: letters, textId: number };
  }
}
